import { LanguageCulture } from "../models/language-culture.model";

export class LanguageCultureOptions {
  public static cultureInfoCode(culture: string): string {
    if (!culture) return '';

    const allCultures = this.all();

    // Try to find an exact match for the culture code
    const exactMatch = allCultures.find(c => c.cultureInfoCode.toLowerCase() === culture.toLowerCase());
    if (exactMatch) return exactMatch.cultureInfoCode;

    // Filter by two-letter language code
    const matchingCultures = allCultures.filter(c => c.twoLetterLangCode.toLowerCase() === culture.toLowerCase());

    // If there's only one match, return it
    if (matchingCultures.length === 1) return matchingCultures[0].cultureInfoCode;

    // If multiple matches, try to find the primary culture
    const primaryCulture = matchingCultures.find(c => c.isPrimaryCulture);
    return primaryCulture ? primaryCulture.cultureInfoCode : '';
  }


  public static all(): LanguageCulture[] {
    return [
      {
        "country": "Afghanistan",
        "language": "Pashto",
        "twoLetterLangCode": "ps",
        "threeLetterLangCode": "pus",
        "cultureInfoCode": "ps-AF", "isPrimaryCulture": false
      },
      {
        "country": "Afghanistan",
        "language": "Dari",
        "twoLetterLangCode": "prs",
        "threeLetterLangCode": "prs",
        "cultureInfoCode": "prs-AF", "isPrimaryCulture": false,
      },
      {
        "country": "Albania",
        "language": "Albanian",
        "twoLetterLangCode": "sq",
        "threeLetterLangCode": "sqi",
        "cultureInfoCode": "sq-AL", "isPrimaryCulture": false,
      },
      {
        "country": "Algeria",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-DZ", "isPrimaryCulture": false,
      },
      {
        "country": "Argentina",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-AR", "isPrimaryCulture": false,
      },
      {
        "country": "Armenia",
        "language": "Armenian",
        "twoLetterLangCode": "hy",
        "threeLetterLangCode": "hye",
        "cultureInfoCode": "hy-AM", "isPrimaryCulture": false,
      },
      {
        "country": "Australia",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-AU", "isPrimaryCulture": false,
      },
      {
        "country": "Austria",
        "language": "German",
        "twoLetterLangCode": "de",
        "threeLetterLangCode": "deu",
        "cultureInfoCode": "de-AT", "isPrimaryCulture": false,
      },
      {
        "country": "Bahrain",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-BH", "isPrimaryCulture": false,
      },
      {
        "country": "Bangladesh",
        "language": "Bengali",
        "twoLetterLangCode": "bn",
        "threeLetterLangCode": "bng",
        "cultureInfoCode": "bn-BD", "isPrimaryCulture": false,
      },
      {
        "country": "Basque",
        "language": "Basque",
        "twoLetterLangCode": "eu",
        "threeLetterLangCode": "eus",
        "cultureInfoCode": "eu-ES", "isPrimaryCulture": false,
      },
      {
        "country": "Belarus",
        "language": "Belarusian",
        "twoLetterLangCode": "be",
        "threeLetterLangCode": "bel",
        "cultureInfoCode": "be-BY", "isPrimaryCulture": false,
      },
      {
        "country": "Belgium",
        "language": "French",
        "twoLetterLangCode": "fr",
        "threeLetterLangCode": "fra",
        "cultureInfoCode": "fr-BE", "isPrimaryCulture": false,
      },
      {
        "country": "Belgium",
        "language": "Dutch",
        "twoLetterLangCode": "nl",
        "threeLetterLangCode": "nld",
        "cultureInfoCode": "nl-BE", "isPrimaryCulture": false,
      },
      {
        "country": "Belize",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-BZ", "isPrimaryCulture": false,
      },
      {
        "country": "Bolivarian Republic of Venezuela",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-VE", "isPrimaryCulture": false,
      },
      {
        "country": "Bolivia",
        "language": "Quechua",
        "twoLetterLangCode": "quz",
        "threeLetterLangCode": "qub",
        "cultureInfoCode": "quz-BO", "isPrimaryCulture": false,
      },
      {
        "country": "Bolivia",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-BO", "isPrimaryCulture": false,
      },
      {
        "country": "Brazil",
        "language": "Portuguese",
        "twoLetterLangCode": "pt",
        "threeLetterLangCode": "por",
        "cultureInfoCode": "pt-BR", "isPrimaryCulture": false,
      },
      {
        "country": "Brunei Darussalam",
        "language": "Malay",
        "twoLetterLangCode": "ms",
        "threeLetterLangCode": "msa",
        "cultureInfoCode": "ms-BN", "isPrimaryCulture": false,
      },
      {
        "country": "Bulgaria",
        "language": "Bulgarian",
        "twoLetterLangCode": "bg",
        "threeLetterLangCode": "bul",
        "cultureInfoCode": "bg-BG", "isPrimaryCulture": false,
      },
      {
        "country": "Cambodia",
        "language": "Khmer",
        "twoLetterLangCode": "km",
        "threeLetterLangCode": "khm",
        "cultureInfoCode": "km-KH", "isPrimaryCulture": false,
      },
      {
        "country": "Canada",
        "language": "French",
        "twoLetterLangCode": "fr",
        "threeLetterLangCode": "fra",
        "cultureInfoCode": "fr-CA", "isPrimaryCulture": false,
      },
      {
        "country": "Canada",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-CA", "isPrimaryCulture": false,
      },
      {
        "country": "Caribbean",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-029", "isPrimaryCulture": false,
      },
      {
        "country": "Catalan",
        "language": "Catalan",
        "twoLetterLangCode": "ca",
        "threeLetterLangCode": "cat",
        "cultureInfoCode": "ca-ES", "isPrimaryCulture": false,
      },
      {
        "country": "Chile",
        "language": "Mapudungun",
        "twoLetterLangCode": "arn",
        "threeLetterLangCode": "arn",
        "cultureInfoCode": "arn-CL", "isPrimaryCulture": false,
      },
      {
        "country": "Chile",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-CL", "isPrimaryCulture": false,
      },
      {
        "country": "Colombia",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-CO", "isPrimaryCulture": false,
      },
      {
        "country": "Costa Rica",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-CR", "isPrimaryCulture": false,
      },
      {
        "country": "Croatia",
        "language": "Croatian",
        "twoLetterLangCode": "hr",
        "threeLetterLangCode": "hrv",
        "cultureInfoCode": "hr-HR", "isPrimaryCulture": false,
      },
      {
        "country": "Cyrillic, Azerbaijan",
        "language": "Azeri",
        "twoLetterLangCode": "az",
        "threeLetterLangCode": "aze",
        "cultureInfoCode": "az-Cyrl-AZ", "isPrimaryCulture": false,
      },
      {
        "country": "Cyrillic, Bosnia and Herzegovina",
        "language": "Serbian",
        "twoLetterLangCode": "sr",
        "threeLetterLangCode": "srn",
        "cultureInfoCode": "sr-Cyrl-BA", "isPrimaryCulture": true,
      },
      {
        "country": "Cyrillic, Bosnia and Herzegovina",
        "language": "Bosnian",
        "twoLetterLangCode": "bs",
        "threeLetterLangCode": "bsc",
        "cultureInfoCode": "bs-Cyrl-BA", "isPrimaryCulture": false,
      },
      {
        "country": "Cyrillic, Mongolia",
        "language": "Mongolian",
        "twoLetterLangCode": "mn",
        "threeLetterLangCode": "mon",
        "cultureInfoCode": "mn-MN", "isPrimaryCulture": false,
      },
      {
        "country": "Cyrillic, Montenegro",
        "language": "Serbian",
        "twoLetterLangCode": "sr",
        "threeLetterLangCode": "srp",
        "cultureInfoCode": "sr-Cyrl-ME", "isPrimaryCulture": false,
      },
      {
        "country": "Cyrillic, Serbia",
        "language": "Serbian",
        "twoLetterLangCode": "sr",
        "threeLetterLangCode": "srp",
        "cultureInfoCode": "sr-Cyrl-RS", "isPrimaryCulture": false,
      },
      {
        "country": "Cyrillic, Serbia and Montenegro (Former",
        "language": "Serbian )",
        "twoLetterLangCode": "sr",
        "threeLetterLangCode": "srp",
        "cultureInfoCode": "sr-Cyrl-CS", "isPrimaryCulture": false,
      },
      {
        "country": "Cyrillic, Tajikistan",
        "language": "Tajik",
        "twoLetterLangCode": "tg",
        "threeLetterLangCode": "tgk",
        "cultureInfoCode": "tg-Cyrl-TJ", "isPrimaryCulture": false,
      },
      {
        "country": "Cyrillic, Uzbekistan",
        "language": "Uzbek",
        "twoLetterLangCode": "uz",
        "threeLetterLangCode": "uzb",
        "cultureInfoCode": "uz-Cyrl-UZ", "isPrimaryCulture": false,
      },
      {
        "country": "Czech Republic",
        "language": "Czech",
        "twoLetterLangCode": "cs",
        "threeLetterLangCode": "ces",
        "cultureInfoCode": "cs-CZ", "isPrimaryCulture": false,
      },
      {
        "country": "Denmark",
        "language": "Danish",
        "twoLetterLangCode": "da",
        "threeLetterLangCode": "dan",
        "cultureInfoCode": "da-DK", "isPrimaryCulture": false,
      },
      {
        "country": "Dominican Republic",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-DO", "isPrimaryCulture": false,
      },
      {
        "country": "Ecuador",
        "language": "Quechua",
        "twoLetterLangCode": "quz",
        "threeLetterLangCode": "que",
        "cultureInfoCode": "quz-EC", "isPrimaryCulture": false,
      },
      {
        "country": "Ecuador",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-EC", "isPrimaryCulture": false,
      },
      {
        "country": "Egypt",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-EG", "isPrimaryCulture": false,
      },
      {
        "country": "El Salvador",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-SV", "isPrimaryCulture": false,
      },
      {
        "country": "Estonia",
        "language": "Estonian",
        "twoLetterLangCode": "et",
        "threeLetterLangCode": "est",
        "cultureInfoCode": "et-EE", "isPrimaryCulture": false,
      },
      {
        "country": "Ethiopia",
        "language": "Amharic",
        "twoLetterLangCode": "am",
        "threeLetterLangCode": "amh",
        "cultureInfoCode": "am-ET", "isPrimaryCulture": false,
      },
      {
        "country": "Faroe Islands",
        "language": "Faroese",
        "twoLetterLangCode": "fo",
        "threeLetterLangCode": "fao",
        "cultureInfoCode": "fo-FO", "isPrimaryCulture": false,
      },
      {
        "country": "Finland",
        "language": "Finnish",
        "twoLetterLangCode": "fi",
        "threeLetterLangCode": "fin",
        "cultureInfoCode": "fi-FI", "isPrimaryCulture": false,
      },
      {
        "country": "Finland",
        "language": "Swedish",
        "twoLetterLangCode": "sv",
        "threeLetterLangCode": "swe",
        "cultureInfoCode": "sv-FI", "isPrimaryCulture": false,
      },
      {
        "country": "Finland",
        "language": "Sami, Northern",
        "twoLetterLangCode": "se",
        "threeLetterLangCode": "smg",
        "cultureInfoCode": "se-FI", "isPrimaryCulture": false,
      },
      {
        "country": "Finland",
        "language": "Sami, Skolt",
        "twoLetterLangCode": "sms",
        "threeLetterLangCode": "sms",
        "cultureInfoCode": "sms-FI", "isPrimaryCulture": false,
      },
      {
        "country": "Finland",
        "language": "Sami, Inari",
        "twoLetterLangCode": "smn",
        "threeLetterLangCode": "smn",
        "cultureInfoCode": "smn-FI", "isPrimaryCulture": false,
      },
      {
        "country": "Former Yugoslav Republic of Macedonia",
        "language": "Macedonian",
        "twoLetterLangCode": "mk",
        "threeLetterLangCode": "mkd",
        "cultureInfoCode": "mk-MK", "isPrimaryCulture": false,
      },
      {
        "country": "France",
        "language": "French",
        "twoLetterLangCode": "fr",
        "threeLetterLangCode": "fra",
        "cultureInfoCode": "fr-FR", "isPrimaryCulture": true,
      },
      {
        "country": "France",
        "language": "Breton",
        "twoLetterLangCode": "br",
        "threeLetterLangCode": "bre",
        "cultureInfoCode": "br-FR", "isPrimaryCulture": false,
      },
      {
        "country": "France",
        "language": "Occitan",
        "twoLetterLangCode": "oc",
        "threeLetterLangCode": "oci",
        "cultureInfoCode": "oc-FR", "isPrimaryCulture": false,
      },
      {
        "country": "France",
        "language": "Corsican",
        "twoLetterLangCode": "co",
        "threeLetterLangCode": "cos",
        "cultureInfoCode": "co-FR", "isPrimaryCulture": false,
      },
      {
        "country": "France",
        "language": "Alsatian",
        "twoLetterLangCode": "gsw",
        "threeLetterLangCode": "gsw",
        "cultureInfoCode": "gsw-FR", "isPrimaryCulture": false,
      },
      {
        "country": "Galician",
        "language": "Galician",
        "twoLetterLangCode": "gl",
        "threeLetterLangCode": "glg",
        "cultureInfoCode": "gl-ES", "isPrimaryCulture": false,
      },
      {
        "country": "Georgia",
        "language": "Georgian",
        "twoLetterLangCode": "ka",
        "threeLetterLangCode": "kat",
        "cultureInfoCode": "ka-GE", "isPrimaryCulture": false,
      },
      {
        "country": "Germany",
        "language": "German",
        "twoLetterLangCode": "de",
        "threeLetterLangCode": "deu",
        "cultureInfoCode": "de-DE", "isPrimaryCulture": true,
      },
      {
        "country": "Germany",
        "language": "Upper Sorbian",
        "twoLetterLangCode": "hsb",
        "threeLetterLangCode": "hsb",
        "cultureInfoCode": "hsb-DE", "isPrimaryCulture": false,
      },
      {
        "country": "Germany",
        "language": "Lower Sorbian",
        "twoLetterLangCode": "dsb",
        "threeLetterLangCode": "dsb",
        "cultureInfoCode": "dsb-DE", "isPrimaryCulture": false,
      },
      {
        "country": "Greece",
        "language": "Greek",
        "twoLetterLangCode": "el",
        "threeLetterLangCode": "ell",
        "cultureInfoCode": "el-GR", "isPrimaryCulture": true,
      },
      {
        "country": "Greenland",
        "language": "Greenlandic",
        "twoLetterLangCode": "kl",
        "threeLetterLangCode": "kal",
        "cultureInfoCode": "kl-GL", "isPrimaryCulture": false,
      },
      {
        "country": "Guatemala",
        "language": "K'iche",
        "twoLetterLangCode": "qut",
        "threeLetterLangCode": "qut",
        "cultureInfoCode": "qut-GT", "isPrimaryCulture": false,
      },
      {
        "country": "Guatemala",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-GT", "isPrimaryCulture": false,
      },
      {
        "country": "Honduras",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-HN", "isPrimaryCulture": false,
      },
      {
        "country": "Hungary",
        "language": "Hungarian",
        "twoLetterLangCode": "hu",
        "threeLetterLangCode": "hun",
        "cultureInfoCode": "hu-HU", "isPrimaryCulture": false,
      },
      {
        "country": "Iceland",
        "language": "Icelandic",
        "twoLetterLangCode": "is",
        "threeLetterLangCode": "isl",
        "cultureInfoCode": "is-IS", "isPrimaryCulture": false,
      },
      {
        "country": "India",
        "language": "Hindi",
        "twoLetterLangCode": "hi",
        "threeLetterLangCode": "hin",
        "cultureInfoCode": "hi-IN", "isPrimaryCulture": false,
      },
      {
        "country": "India",
        "language": "Bengali",
        "twoLetterLangCode": "bn",
        "threeLetterLangCode": "bng",
        "cultureInfoCode": "bn-IN", "isPrimaryCulture": false,
      },
      {
        "country": "India",
        "language": "Punjabi",
        "twoLetterLangCode": "pa",
        "threeLetterLangCode": "pan",
        "cultureInfoCode": "pa-IN", "isPrimaryCulture": false,
      },
      {
        "country": "India",
        "language": "Gujarati",
        "twoLetterLangCode": "gu",
        "threeLetterLangCode": "guj",
        "cultureInfoCode": "gu-IN", "isPrimaryCulture": false,
      },
      {
        "country": "India",
        "language": "Oriya",
        "twoLetterLangCode": "or",
        "threeLetterLangCode": "ori",
        "cultureInfoCode": "or-IN", "isPrimaryCulture": false,
      },
      {
        "country": "India",
        "language": "Tamil",
        "twoLetterLangCode": "ta",
        "threeLetterLangCode": "tam",
        "cultureInfoCode": "ta-IN", "isPrimaryCulture": false,
      },
      {
        "country": "India",
        "language": "Telugu",
        "twoLetterLangCode": "te",
        "threeLetterLangCode": "tel",
        "cultureInfoCode": "te-IN", "isPrimaryCulture": false,
      },
      {
        "country": "India",
        "language": "Kannada",
        "twoLetterLangCode": "kn",
        "threeLetterLangCode": "kan",
        "cultureInfoCode": "kn-IN", "isPrimaryCulture": false,
      },
      {
        "country": "India",
        "language": "Malayalam",
        "twoLetterLangCode": "ml",
        "threeLetterLangCode": "mym",
        "cultureInfoCode": "ml-IN", "isPrimaryCulture": false,
      },
      {
        "country": "India",
        "language": "Assamese",
        "twoLetterLangCode": "as",
        "threeLetterLangCode": "asm",
        "cultureInfoCode": "as-IN", "isPrimaryCulture": false,
      },
      {
        "country": "India",
        "language": "Marathi",
        "twoLetterLangCode": "mr",
        "threeLetterLangCode": "mar",
        "cultureInfoCode": "mr-IN", "isPrimaryCulture": false,
      },
      {
        "country": "India",
        "language": "Sanskrit",
        "twoLetterLangCode": "sa",
        "threeLetterLangCode": "san",
        "cultureInfoCode": "sa-IN", "isPrimaryCulture": false,
      },
      {
        "country": "India",
        "language": "Konkani",
        "twoLetterLangCode": "kok",
        "threeLetterLangCode": "kok",
        "cultureInfoCode": "kok-IN", "isPrimaryCulture": false,
      },
      {
        "country": "India",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-IN", "isPrimaryCulture": false,
      },
      {
        "country": "Indonesia",
        "language": "Indonesian",
        "twoLetterLangCode": "id",
        "threeLetterLangCode": "ind",
        "cultureInfoCode": "id-ID", "isPrimaryCulture": false,
      },
      {
        "country": "Iran",
        "language": "Persian",
        "twoLetterLangCode": "fa",
        "threeLetterLangCode": "fas",
        "cultureInfoCode": "fa-IR", "isPrimaryCulture": false,
      },
      {
        "country": "Iraq",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-IQ", "isPrimaryCulture": false,
      },
      {
        "country": "Ireland",
        "language": "Irish",
        "twoLetterLangCode": "ga",
        "threeLetterLangCode": "gle",
        "cultureInfoCode": "ga-IE", "isPrimaryCulture": false,
      },
      {
        "country": "Ireland",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-IE", "isPrimaryCulture": false,
      },
      {
        "country": "Islamic Republic of Pakistan",
        "language": "Urdu",
        "twoLetterLangCode": "ur",
        "threeLetterLangCode": "urd",
        "cultureInfoCode": "ur-PK", "isPrimaryCulture": false,
      },
      {
        "country": "Israel",
        "language": "Hebrew",
        "twoLetterLangCode": "he",
        "threeLetterLangCode": "heb",
        "cultureInfoCode": "he-IL", "isPrimaryCulture": false,
      },
      {
        "country": "Italy",
        "language": "Italian",
        "twoLetterLangCode": "it",
        "threeLetterLangCode": "ita",
        "cultureInfoCode": "it-IT", "isPrimaryCulture": true,
      },
      {
        "country": "Jamaica",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-JM", "isPrimaryCulture": false,
      },
      {
        "country": "Japan",
        "language": "Japanese",
        "twoLetterLangCode": "ja",
        "threeLetterLangCode": "jpn",
        "cultureInfoCode": "ja-JP", "isPrimaryCulture": false,
      },
      {
        "country": "Jordan",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-JO", "isPrimaryCulture": false,
      },
      {
        "country": "Kazakhstan",
        "language": "Kazakh",
        "twoLetterLangCode": "kk",
        "threeLetterLangCode": "kaz",
        "cultureInfoCode": "kk-KZ", "isPrimaryCulture": false,
      },
      {
        "country": "Kenya",
        "language": "Kiswahili",
        "twoLetterLangCode": "sw",
        "threeLetterLangCode": "swa",
        "cultureInfoCode": "sw-KE", "isPrimaryCulture": false,
      },
      {
        "country": "Korea",
        "language": "Korean",
        "twoLetterLangCode": "ko",
        "threeLetterLangCode": "kor",
        "cultureInfoCode": "ko-KR", "isPrimaryCulture": true,
      },
      {
        "country": "Kuwait",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-KW", "isPrimaryCulture": false,
      },
      {
        "country": "Kyrgyzstan",
        "language": "Kyrgyz",
        "twoLetterLangCode": "ky",
        "threeLetterLangCode": "kir",
        "cultureInfoCode": "ky-KG", "isPrimaryCulture": false,
      },
      {
        "country": "Lao P.D.R.",
        "language": "Lao",
        "twoLetterLangCode": "lo",
        "threeLetterLangCode": "lao",
        "cultureInfoCode": "lo-LA", "isPrimaryCulture": false,
      },
      {
        "country": "Latin, Algeria",
        "language": "Tamazight",
        "twoLetterLangCode": "tzm",
        "threeLetterLangCode": "tzm",
        "cultureInfoCode": "tzm-Latn-DZ", "isPrimaryCulture": false,
      },
      {
        "country": "Latin, Azerbaijan",
        "language": "Azeri",
        "twoLetterLangCode": "az",
        "threeLetterLangCode": "aze",
        "cultureInfoCode": "az-Latn-AZ", "isPrimaryCulture": false,
      },
      {
        "country": "Latin, Bosnia and Herzegovina",
        "language": "Croatian",
        "twoLetterLangCode": "hr",
        "threeLetterLangCode": "hrb",
        "cultureInfoCode": "hr-BA", "isPrimaryCulture": false,
      },
      {
        "country": "Latin, Bosnia and Herzegovina",
        "language": "Bosnian",
        "twoLetterLangCode": "bs",
        "threeLetterLangCode": "bsb",
        "cultureInfoCode": "bs-Latn-BA", "isPrimaryCulture": false,
      },
      {
        "country": "Latin, Bosnia and Herzegovina",
        "language": "Serbian",
        "twoLetterLangCode": "sr",
        "threeLetterLangCode": "srs",
        "cultureInfoCode": "sr-Latn-BA", "isPrimaryCulture": false,
      },
      {
        "country": "Latin, Canada",
        "language": "Inuktitut",
        "twoLetterLangCode": "iu",
        "threeLetterLangCode": "iku",
        "cultureInfoCode": "iu-Latn-CA", "isPrimaryCulture": false,
      },
      {
        "country": "Latin, Montenegro",
        "language": "Serbian",
        "twoLetterLangCode": "sr",
        "threeLetterLangCode": "srp",
        "cultureInfoCode": "sr-Latn-ME", "isPrimaryCulture": false,
      },
      {
        "country": "Latin, Nigeria",
        "language": "Hausa",
        "twoLetterLangCode": "ha",
        "threeLetterLangCode": "hau",
        "cultureInfoCode": "ha-Latn-NG", "isPrimaryCulture": false,
      },
      {
        "country": "Latin, Serbia",
        "language": "Serbian",
        "twoLetterLangCode": "sr",
        "threeLetterLangCode": "srp",
        "cultureInfoCode": "sr-Latn-RS", "isPrimaryCulture": false,
      },
      {
        "country": "Latin, Serbia and Montenegro (Former",
        "language": "Serbian )",
        "twoLetterLangCode": "sr",
        "threeLetterLangCode": "srp",
        "cultureInfoCode": "sr-Latn-CS", "isPrimaryCulture": false,
      },
      {
        "country": "Latin, Uzbekistan",
        "language": "Uzbek",
        "twoLetterLangCode": "uz",
        "threeLetterLangCode": "uzb",
        "cultureInfoCode": "uz-Latn-UZ", "isPrimaryCulture": false,
      },
      {
        "country": "Latvia",
        "language": "Latvian",
        "twoLetterLangCode": "lv",
        "threeLetterLangCode": "lav",
        "cultureInfoCode": "lv-LV", "isPrimaryCulture": false,
      },
      {
        "country": "Lebanon",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-LB", "isPrimaryCulture": false,
      },
      {
        "country": "Libya",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-LY", "isPrimaryCulture": false,
      },
      {
        "country": "Liechtenstein",
        "language": "German",
        "twoLetterLangCode": "de",
        "threeLetterLangCode": "deu",
        "cultureInfoCode": "de-LI", "isPrimaryCulture": false,
      },
      {
        "country": "Lithuania",
        "language": "Lithuanian",
        "twoLetterLangCode": "lt",
        "threeLetterLangCode": "lit",
        "cultureInfoCode": "lt-LT", "isPrimaryCulture": false,
      },
      {
        "country": "Luxembourg",
        "language": "Luxembourgish",
        "twoLetterLangCode": "lb",
        "threeLetterLangCode": "ltz",
        "cultureInfoCode": "lb-LU", "isPrimaryCulture": false,
      },
      {
        "country": "Luxembourg",
        "language": "German",
        "twoLetterLangCode": "de",
        "threeLetterLangCode": "deu",
        "cultureInfoCode": "de-LU", "isPrimaryCulture": false,
      },
      {
        "country": "Luxembourg",
        "language": "French",
        "twoLetterLangCode": "fr",
        "threeLetterLangCode": "fra",
        "cultureInfoCode": "fr-LU", "isPrimaryCulture": false,
      },
      {
        "country": "Malaysia",
        "language": "Malay",
        "twoLetterLangCode": "ms",
        "threeLetterLangCode": "msa",
        "cultureInfoCode": "ms-MY", "isPrimaryCulture": false,
      },
      {
        "country": "Malaysia",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-MY", "isPrimaryCulture": false,
      },
      {
        "country": "Maldives",
        "language": "Divehi",
        "twoLetterLangCode": "dv",
        "threeLetterLangCode": "div",
        "cultureInfoCode": "dv-MV", "isPrimaryCulture": false,
      },
      {
        "country": "Malta",
        "language": "Maltese",
        "twoLetterLangCode": "mt",
        "threeLetterLangCode": "mlt",
        "cultureInfoCode": "mt-MT", "isPrimaryCulture": false,
      },
      {
        "country": "Mexico",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-MX", "isPrimaryCulture": false,
      },
      {
        "country": "Mohawk",
        "language": "Mohawk",
        "twoLetterLangCode": "moh",
        "threeLetterLangCode": "moh",
        "cultureInfoCode": "moh-CA", "isPrimaryCulture": false,
      },
      {
        "country": "Monaco",
        "language": "French",
        "twoLetterLangCode": "fr",
        "threeLetterLangCode": "fra",
        "cultureInfoCode": "fr-MC", "isPrimaryCulture": false,
      },
      {
        "country": "Morocco",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-MA", "isPrimaryCulture": false,
      },
      {
        "country": "Nepal",
        "language": "Nepali",
        "twoLetterLangCode": "ne",
        "threeLetterLangCode": "nep",
        "cultureInfoCode": "ne-NP", "isPrimaryCulture": false,
      },
      {
        "country": "Netherlands",
        "language": "Dutch",
        "twoLetterLangCode": "nl",
        "threeLetterLangCode": "nld",
        "cultureInfoCode": "nl-NL", "isPrimaryCulture": true,
      },
      {
        "country": "Netherlands",
        "language": "Frisian",
        "twoLetterLangCode": "fy",
        "threeLetterLangCode": "fry",
        "cultureInfoCode": "fy-NL", "isPrimaryCulture": false,
      },
      {
        "country": "New Zealand",
        "language": "Maori",
        "twoLetterLangCode": "mi",
        "threeLetterLangCode": "mri",
        "cultureInfoCode": "mi-NZ", "isPrimaryCulture": false,
      },
      {
        "country": "New Zealand",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-NZ", "isPrimaryCulture": false,
      },
      {
        "country": "Nicaragua",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-NI", "isPrimaryCulture": false,
      },
      {
        "country": "Nigeria",
        "language": "Yoruba",
        "twoLetterLangCode": "yo",
        "threeLetterLangCode": "yor",
        "cultureInfoCode": "yo-NG", "isPrimaryCulture": false,
      },
      {
        "country": "Nigeria",
        "language": "Igbo",
        "twoLetterLangCode": "ig",
        "threeLetterLangCode": "ibo",
        "cultureInfoCode": "ig-NG", "isPrimaryCulture": false,
      },
      {
        "country": "Norway",
        "language": "Norwegian, Bokmål",
        "twoLetterLangCode": "nb",
        "threeLetterLangCode": "nob",
        "cultureInfoCode": "nb-NO", "isPrimaryCulture": true,
      },
      {
        "country": "Norway",
        "language": "Sami, Northern",
        "twoLetterLangCode": "se",
        "threeLetterLangCode": "sme",
        "cultureInfoCode": "se-NO", "isPrimaryCulture": false,
      },
      {
        "country": "Norway",
        "language": "Norwegian, Nynorsk",
        "twoLetterLangCode": "nn",
        "threeLetterLangCode": "nno",
        "cultureInfoCode": "nn-NO", "isPrimaryCulture": false,
      },
      {
        "country": "Norway",
        "language": "Sami, Lule",
        "twoLetterLangCode": "smj",
        "threeLetterLangCode": "smj",
        "cultureInfoCode": "smj-NO", "isPrimaryCulture": false,
      },
      {
        "country": "Norway",
        "language": "Sami, Southern",
        "twoLetterLangCode": "sma",
        "threeLetterLangCode": "sma",
        "cultureInfoCode": "sma-NO", "isPrimaryCulture": false,
      },
      {
        "country": "Oman",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-OM", "isPrimaryCulture": false,
      },
      {
        "country": "Panama",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-PA", "isPrimaryCulture": false,
      },
      {
        "country": "Paraguay",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-PY", "isPrimaryCulture": false,
      },
      {
        "country": "Peru",
        "language": "Quechua",
        "twoLetterLangCode": "quz",
        "threeLetterLangCode": "qup",
        "cultureInfoCode": "quz-PE", "isPrimaryCulture": false,
      },
      {
        "country": "Peru",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-PE", "isPrimaryCulture": false,
      },
      {
        "country": "Philippines",
        "language": "Filipino",
        "twoLetterLangCode": "fil",
        "threeLetterLangCode": "fil",
        "cultureInfoCode": "fil-PH", "isPrimaryCulture": false,
      },
      {
        "country": "Poland",
        "language": "Polish",
        "twoLetterLangCode": "pl",
        "threeLetterLangCode": "pol",
        "cultureInfoCode": "pl-PL", "isPrimaryCulture": false,
      },
      {
        "country": "Portugal",
        "language": "Portuguese",
        "twoLetterLangCode": "pt",
        "threeLetterLangCode": "por",
        "cultureInfoCode": "pt-PT", "isPrimaryCulture": true,
      },
      {
        "country": "PRC",
        "language": "Tibetan",
        "twoLetterLangCode": "bo",
        "threeLetterLangCode": "bod",
        "cultureInfoCode": "bo-CN", "isPrimaryCulture": false,
      },
      {
        "country": "PRC",
        "language": "Yi",
        "twoLetterLangCode": "ii",
        "threeLetterLangCode": "iii",
        "cultureInfoCode": "ii-CN", "isPrimaryCulture": false,
      },
      {
        "country": "PRC",
        "language": "Uyghur",
        "twoLetterLangCode": "ug",
        "threeLetterLangCode": "uig",
        "cultureInfoCode": "ug-CN", "isPrimaryCulture": false,
      },
      {
        "country": "Puerto Rico",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-PR", "isPrimaryCulture": false,
      },
      {
        "country": "Qatar",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-QA", "isPrimaryCulture": false,
      },
      {
        "country": "Republic of the Philippines",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-PH", "isPrimaryCulture": false,
      },
      {
        "country": "Romania",
        "language": "Romanian",
        "twoLetterLangCode": "ro",
        "threeLetterLangCode": "ron",
        "cultureInfoCode": "ro-RO", "isPrimaryCulture": false,
      },
      {
        "country": "Russia",
        "language": "Russian",
        "twoLetterLangCode": "ru",
        "threeLetterLangCode": "rus",
        "cultureInfoCode": "ru-RU", "isPrimaryCulture": true,
      },
      {
        "country": "Russia",
        "language": "Tatar",
        "twoLetterLangCode": "tt",
        "threeLetterLangCode": "tat",
        "cultureInfoCode": "tt-RU", "isPrimaryCulture": false,
      },
      {
        "country": "Russia",
        "language": "Bashkir",
        "twoLetterLangCode": "ba",
        "threeLetterLangCode": "bak",
        "cultureInfoCode": "ba-RU", "isPrimaryCulture": false,
      },
      {
        "country": "Russia",
        "language": "Yakut",
        "twoLetterLangCode": "sah",
        "threeLetterLangCode": "sah",
        "cultureInfoCode": "sah-RU", "isPrimaryCulture": false,
      },
      {
        "country": "Rwanda",
        "language": "Kinyarwanda",
        "twoLetterLangCode": "rw",
        "threeLetterLangCode": "kin",
        "cultureInfoCode": "rw-RW", "isPrimaryCulture": false,
      },
      {
        "country": "Saudi Arabia",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-SA", "isPrimaryCulture": true,
      },
      {
        "country": "Senegal",
        "language": "Wolof",
        "twoLetterLangCode": "wo",
        "threeLetterLangCode": "wol",
        "cultureInfoCode": "wo-SN", "isPrimaryCulture": false,
      },
      {
        "country": "Simplified, PRC",
        "language": "Chinese",
        "twoLetterLangCode": "zh",
        "threeLetterLangCode": "zho",
        "cultureInfoCode": "zh-CN", "isPrimaryCulture": true,
      },
      {
        "country": "Simplified, Singapore",
        "language": "Chinese",
        "twoLetterLangCode": "zh",
        "threeLetterLangCode": "zho",
        "cultureInfoCode": "zh-SG", "isPrimaryCulture": false,
      },
      {
        "country": "Singapore",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-SG", "isPrimaryCulture": false,
      },
      {
        "country": "Slovakia",
        "language": "Slovak",
        "twoLetterLangCode": "sk",
        "threeLetterLangCode": "slk",
        "cultureInfoCode": "sk-SK", "isPrimaryCulture": false,
      },
      {
        "country": "Slovenia",
        "language": "Slovenian",
        "twoLetterLangCode": "sl",
        "threeLetterLangCode": "slv",
        "cultureInfoCode": "sl-SI", "isPrimaryCulture": false,
      },
      {
        "country": "South Africa",
        "language": "Setswana",
        "twoLetterLangCode": "tn",
        "threeLetterLangCode": "tsn",
        "cultureInfoCode": "tn-ZA", "isPrimaryCulture": false,
      },
      {
        "country": "South Africa",
        "language": "isiXhosa",
        "twoLetterLangCode": "xh",
        "threeLetterLangCode": "xho",
        "cultureInfoCode": "xh-ZA", "isPrimaryCulture": false,
      },
      {
        "country": "South Africa",
        "language": "isiZulu",
        "twoLetterLangCode": "zu",
        "threeLetterLangCode": "zul",
        "cultureInfoCode": "zu-ZA", "isPrimaryCulture": false,
      },
      {
        "country": "South Africa",
        "language": "Afrikaans",
        "twoLetterLangCode": "af",
        "threeLetterLangCode": "afr",
        "cultureInfoCode": "af-ZA", "isPrimaryCulture": false,
      },
      {
        "country": "South Africa",
        "language": "Sesotho sa Leboa",
        "twoLetterLangCode": "nso",
        "threeLetterLangCode": "nso",
        "cultureInfoCode": "nso-ZA", "isPrimaryCulture": false,
      },
      {
        "country": "South Africa",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-ZA", "isPrimaryCulture": false,
      },
      {
        "country": "Spain, International Sort",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-ES", "isPrimaryCulture": true,
      },
      {
        "country": "Sri Lanka",
        "language": "Sinhala",
        "twoLetterLangCode": "si",
        "threeLetterLangCode": "sin",
        "cultureInfoCode": "si-LK", "isPrimaryCulture": false,
      },
      {
        "country": "Sweden",
        "language": "Swedish",
        "twoLetterLangCode": "sv",
        "threeLetterLangCode": "swe",
        "cultureInfoCode": "sv-SE", "isPrimaryCulture": true,
      },
      {
        "country": "Sweden",
        "language": "Sami, Northern",
        "twoLetterLangCode": "se",
        "threeLetterLangCode": "smf",
        "cultureInfoCode": "se-SE", "isPrimaryCulture": false,
      },
      {
        "country": "Sweden",
        "language": "Sami, Lule",
        "twoLetterLangCode": "smj",
        "threeLetterLangCode": "smk",
        "cultureInfoCode": "smj-SE", "isPrimaryCulture": false,
      },
      {
        "country": "Sweden",
        "language": "Sami, Southern",
        "twoLetterLangCode": "sma",
        "threeLetterLangCode": "smb",
        "cultureInfoCode": "sma-SE", "isPrimaryCulture": false,
      },
      {
        "country": "Switzerland",
        "language": "Romansh",
        "twoLetterLangCode": "rm",
        "threeLetterLangCode": "roh",
        "cultureInfoCode": "rm-CH", "isPrimaryCulture": false,
      },
      {
        "country": "Switzerland",
        "language": "German",
        "twoLetterLangCode": "de",
        "threeLetterLangCode": "deu",
        "cultureInfoCode": "de-CH", "isPrimaryCulture": false,
      },
      {
        "country": "Switzerland",
        "language": "Italian",
        "twoLetterLangCode": "it",
        "threeLetterLangCode": "ita",
        "cultureInfoCode": "it-CH", "isPrimaryCulture": false,
      },
      {
        "country": "Switzerland",
        "language": "French",
        "twoLetterLangCode": "fr",
        "threeLetterLangCode": "fra",
        "cultureInfoCode": "fr-CH", "isPrimaryCulture": false,
      },
      {
        "country": "Syllabics, Canada",
        "language": "Inuktitut",
        "twoLetterLangCode": "iu",
        "threeLetterLangCode": "iku",
        "cultureInfoCode": "iu-Cans-CA", "isPrimaryCulture": false,
      },
      {
        "country": "Syria",
        "language": "Syriac",
        "twoLetterLangCode": "syr",
        "threeLetterLangCode": "syr",
        "cultureInfoCode": "syr-SY", "isPrimaryCulture": false,
      },
      {
        "country": "Syria",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-SY", "isPrimaryCulture": false,
      },
      {
        "country": "Thailand",
        "language": "Thai",
        "twoLetterLangCode": "th",
        "threeLetterLangCode": "tha",
        "cultureInfoCode": "th-TH", "isPrimaryCulture": false,
      },
      {
        "country": "Traditional Mongolian, PRC",
        "language": "Mongolian",
        "twoLetterLangCode": "mn",
        "threeLetterLangCode": "mon",
        "cultureInfoCode": "mn-Mong-CN", "isPrimaryCulture": false,
      },
      {
        "country": "Traditional, Hong Kong S.A.R.",
        "language": "Chinese",
        "twoLetterLangCode": "zh",
        "threeLetterLangCode": "zho",
        "cultureInfoCode": "zh-HK", "isPrimaryCulture": false,
      },
      {
        "country": "Traditional, Macao S.A.R.",
        "language": "Chinese",
        "twoLetterLangCode": "zh",
        "threeLetterLangCode": "zho",
        "cultureInfoCode": "zh-MO", "isPrimaryCulture": false,
      },
      {
        "country": "Traditional, Taiwan",
        "language": "Chinese",
        "twoLetterLangCode": "zh",
        "threeLetterLangCode": "zho",
        "cultureInfoCode": "zh-TW", "isPrimaryCulture": false,
      },
      {
        "country": "Trinidad and Tobago",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-TT", "isPrimaryCulture": false,
      },
      {
        "country": "Tunisia",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-TN", "isPrimaryCulture": false,
      },
      {
        "country": "Turkey",
        "language": "Turkish",
        "twoLetterLangCode": "tr",
        "threeLetterLangCode": "tur",
        "cultureInfoCode": "tr-TR", "isPrimaryCulture": false,
      },
      {
        "country": "Turkmenistan",
        "language": "Turkmen",
        "twoLetterLangCode": "tk",
        "threeLetterLangCode": "tuk",
        "cultureInfoCode": "tk-TM", "isPrimaryCulture": false,
      },
      {
        "country": "U.A.E.",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-AE", "isPrimaryCulture": false,
      },
      {
        "country": "Ukraine",
        "language": "Ukrainian",
        "twoLetterLangCode": "uk",
        "threeLetterLangCode": "ukr",
        "cultureInfoCode": "uk-UA", "isPrimaryCulture": false,
      },
      {
        "country": "United Kingdom",
        "language": "Welsh",
        "twoLetterLangCode": "cy",
        "threeLetterLangCode": "cym",
        "cultureInfoCode": "cy-GB", "isPrimaryCulture": false,
      },
      {
        "country": "United Kingdom",
        "language": "Scottish Gaelic",
        "twoLetterLangCode": "gd",
        "threeLetterLangCode": "gla",
        "cultureInfoCode": "gd-GB", "isPrimaryCulture": false,
      },
      {
        "country": "United Kingdom",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-GB", "isPrimaryCulture": false,
      },
      {
        "country": "United States",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-US",
        "isPrimaryCulture": true,
      },
      {
        "country": "United States",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-US", "isPrimaryCulture": false,
      },
      {
        "country": "Uruguay",
        "language": "Spanish",
        "twoLetterLangCode": "es",
        "threeLetterLangCode": "spa",
        "cultureInfoCode": "es-UY", "isPrimaryCulture": false,
      },
      {
        "country": "Vietnam",
        "language": "Vietnamese",
        "twoLetterLangCode": "vi",
        "threeLetterLangCode": "vie",
        "cultureInfoCode": "vi-VN", "isPrimaryCulture": false,
      },
      {
        "country": "Yemen",
        "language": "Arabic",
        "twoLetterLangCode": "ar",
        "threeLetterLangCode": "ara",
        "cultureInfoCode": "ar-YE", "isPrimaryCulture": false,
      },
      {
        "country": "Zimbabwe",
        "language": "English",
        "twoLetterLangCode": "en",
        "threeLetterLangCode": "eng",
        "cultureInfoCode": "en-ZW",
        "isPrimaryCulture": false
      }
    ]
  }
}
